import { BaseService } from '@/modules/Core/services/BaseService'
import type { IConfFuncion } from '@/modules/Administracion/interfaces'
export class FuncionService extends BaseService<IConfFuncion> {
  constructor () {
    super({
      baseUrl: 'system/functions/'
    })
  }
  
}
